const AUTHENTICATION_KEY = 'authentication';
const BRANDING_KEY = 'branding';
const TEAM_LOGO_URL = 'logo';
const VIDEO_SETTINGS = 'video';

export function setAuthInLocalStorage(authData) {
  localStorage.setItem(AUTHENTICATION_KEY, JSON.stringify(authData));
}

export function getAuthInLocalStorage() {
  const entry = localStorage.getItem(AUTHENTICATION_KEY);
  return JSON.parse(entry);
}

export function clearAuthInLocalStorage() {
  localStorage.removeItem(AUTHENTICATION_KEY);
}

export function setBrandingInLocalStorage(branding) {
  localStorage.setItem(BRANDING_KEY, JSON.stringify(branding));
}

export function getBradingInLocalStorage() {
  const entry = localStorage.getItem(BRANDING_KEY);
  return JSON.parse(entry);
}

export function setTeamLogoInLocalStorage(url) {
  localStorage.setItem(TEAM_LOGO_URL, url);
}

export function getTeamLogoInLocalStorage() {
  return localStorage.getItem(TEAM_LOGO_URL);
}

export function setVideoSettingsInLocalStorage(settings) {
  localStorage.setItem(VIDEO_SETTINGS, JSON.stringify(settings));
}

export function getVideoSettingsFromLocalStorage() {
  const settings = localStorage.getItem(VIDEO_SETTINGS);
  return JSON.parse(settings);
}
